import { render, staticRenderFns } from "./KWDateView.vue?vue&type=template&id=5fd12868&scoped=true&"
import script from "./KWDateView.vue?vue&type=script&lang=js&"
export * from "./KWDateView.vue?vue&type=script&lang=js&"
import style0 from "./KWDateView.vue?vue&type=style&index=0&id=5fd12868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd12868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
